import React from "react";
import { Box, CardMedia } from "@mui/material";

export interface IFrameProps {
  src: string;
}

const IFrame = ({ src }: IFrameProps) => {
  return (
    <Box sx={{ width: "393px", height: "780px" }}>
      <CardMedia
        component="iframe"
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        sx={{ borderRadius: "24px", marginBottom: "10px" }}
      />
    </Box>
  );
};

export default IFrame;
